import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Form, Header } from 'semantic-ui-react';
import _isFunction from 'lodash/isFunction';
import RecaptchaTermsNotice from './components/RecaptchaTermsNotice';
import { ChildrenPropType } from '../../services/proptypes';
import { classNames } from '../../utils/classname';
import { useRecaptcha } from '../RecaptchaProvider/RecaptchaProvider.hooks';
import { getSiteKey } from '../RecaptchaProvider/RecaptchaProvider.utils';
import './RecaptchaForm.css';
var defaultProps = {
  success: false,
  error: false,
  loading: false,
  className: '',
  title: '',
  hideRecaptchaNotice: false
};
export default function RecaptchaForm(_ref) {
  var children = _ref.children,
    success = _ref.success,
    error = _ref.error,
    loadingProp = _ref.loading,
    className = _ref.className,
    title = _ref.title,
    onSubmit = _ref.onSubmit,
    action = _ref.action,
    hideRecaptchaNotice = _ref.hideRecaptchaNotice;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 2),
    executeRecaptcha = _useRecaptcha2[0],
    recaptchaLoaded = _useRecaptcha2[1];
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var token;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setSubmitting(true);
            _context.next = 4;
            return executeRecaptcha(action);
          case 4:
            token = _context.sent;
            _context.next = 7;
            return onSubmit(event, token);
          case 7:
            _context.next = 11;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
          case 11:
            _context.prev = 11;
            setSubmitting(false);
            return _context.finish(11);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9, 11, 14]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  function getFormContent() {
    if (_isFunction(children)) {
      return children({
        submitting: submitting
      });
    }
    return children;
  }
  var finalLoading = !recaptchaLoaded || loadingProp || submitting;
  var finalClassName = classNames(_defineProperty({
    'recaptcha-form': true
  }, className, true));
  return /*#__PURE__*/React.createElement(Form, {
    className: finalClassName,
    onSubmit: handleSubmit,
    loading: finalLoading,
    success: success,
    error: error
  }, title && /*#__PURE__*/React.createElement(Header, {
    as: "h2"
  }, " ", title), getFormContent(), getSiteKey() && !hideRecaptchaNotice && /*#__PURE__*/React.createElement(RecaptchaTermsNotice, null));
}
RecaptchaForm.defaultProps = defaultProps;